import React from "react";
import dayjs from "dayjs";
import ScheduleCalendar from "./ScheduleCalendar";
import { getDueTimePart } from "../shared/utils/dueDateTime";

function getEventDateValue(item) {
  return item?.start_datetime;
}

function getEventItemKey(item, index) {
  const id = item?._id != null ? String(item._id) : "event";
  const participantId = item?.participant_id != null ? String(item.participant_id) : "";
  return `${id}-${participantId}-${index}`;
}

function getEventLabel(item) {
  const name = (item?.name || "Event").trim() || "Event";
  if (!getDueTimePart(item?.start_datetime)) return name;
  const start = dayjs(item.start_datetime).format("h:mm A");
  const end = item?.end_datetime ? ` – ${dayjs(item.end_datetime).format("h:mm A")}` : "";
  return `${name} · ${start}${end}`;
}

/**
 * Event-specific schedule calendar (Available / Registered / Completed / Event Management).
 * Thin preset over shared ScheduleCalendar — no duplicated day/week/month markup.
 */
export default function EventScheduleCalendar({
  items,
  view,
  focusDateYmd,
  onItemClick,
  emptyDayMessage = "No events this day",
}) {
  return (
    <ScheduleCalendar
      items={items}
      view={view}
      focusDateYmd={focusDateYmd}
      onItemClick={onItemClick}
      emptyDayMessage={emptyDayMessage}
      getDateValue={getEventDateValue}
      getItemKey={getEventItemKey}
      getLabel={getEventLabel}
    />
  );
}
